import React, { useState } from "react";
import { NAV } from "../data/content";
import RainbowText from "./RainbowText";

export default function Topbar() {
  const [open, setOpen] = useState(false);

  const goCal = () => {
    setOpen(false);
    document.getElementById("calendario")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="topbar">
      <span className="tape l" />
      <span className="tape r" />
      <div className="brand-mini">
        <span className="dot" />
        <RainbowText text="LoREMi G" className="wordmark" />
      </div>

      <button
        className={"menu-toggle" + (open ? " open" : "")}
        aria-label={open ? "Cerrar menú" : "Abrir menú"}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <span />
        <span />
        <span />
      </button>

      <div className={"nav-drawer" + (open ? " open" : "")}>
        <nav>
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className={"c-" + n.c}
              onClick={() => setOpen(false)}
            >
              {n.label}
            </a>
          ))}
        </nav>
        <button className="saddle" onClick={goCal}>
          Reservar fecha
        </button>
      </div>
    </header>
  );
}
